const lipFiller = {
  hero: {
    titlePrefix: "Премиум",
    titleAccent: "Филъри за Устни",
    description:
      "Подчертайте естествената си красота с нашите безопасни и ефективни процедури за уголемяване на устни, създадени да ви дадат перфектните, плътни устни, за които винаги сте мечтали.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Научете за Процеса",
    },
    imageAlt:
      "Жена с плътни, естествено изглеждащи устни след третиране с филър",
    callout: {
      title: "Естествен Вид",
      body: "Нашите филъри подчертават естествената ви красота без изкуствен вид",
    },
  },
  benefits: {
    headingPrefix: "Предимства на",
    headingAccent: "Филърите за Устни",
    intro:
      "Открийте как нашите премиум филъри за устни могат да подобрят вашата лицева естетика и да повишат самочувствието ви.",
    items: [
      {
        title: "Естествено Подобрение",
        description:
          "Нашите филъри подчертават естествената форма на устните ви, вместо да създават очевидно изкуствен вид.",
      },
      {
        title: "Незабавни Резултати",
        description:
          "Виждате видими подобрения веднага след процедурата с минимално време за възстановяване.",
      },
      {
        title: "Регулируем Обем",
        description:
          "Обемът на устните Ви се прецизира от наш специалист в областта. Той ще Ви даде съвет за оптималното количество филър,който да бъде инжектиран в устните Ви. Така гарантираме, че резултатът ще Ви очарова .",
      },
      {
        title: "Подобрена Форма",
        description:
          "Коригираме асиметрията и очертаваме контурите на устните ви за по-естествен вид.",
      },
      {
        title: "Намалени Фини Линии",
        description:
          "Изглаждаме вертикалните линии на устните и бръчките около устата.",
      },
      {
        title: "Временни Резултати",
        description:
          "Насладете се на гъвкавостта на непостоянно решение, което обикновено трае 6-12 месеца.",
      },
    ],
  },
  process: {
    headingPrefix: "Процес на",
    headingAccent: "Поставяне",
    intro:
      "Нашите премиум процедури за филъри следват прецизен процес, за да гарантират безопасност, комфорт и красиви, естествено изглеждащи резултати.",
    steps: [
      {
        title: "Консултация",
        description:
          "Среща с нашия специалист, за да обсъдите вашите цели и очаквания за подобрение на устните.",
      },
      {
        title: "Планиране на Лечението",
        description:
          "Ще създадем персонализиран план за лечение, съобразен с вашите лицеви характеристики и желан резултат.",
      },
      {
        title: "Подготовка",
        description:
          "Прилага се локален обезболяващ крем, за да осигурим вашия комфорт по време на процедурата.",
      },
      {
        title: "Инжектиране",
        description:
          "Нашият специалист внимателно ще инжектира дермалния филър за постигане на естествен обем и дефиниция.",
      },
      {
        title: "Резултати",
        description:
          "Насладете се на незабавни резултати, които ще продължат да се подобряват през следващите няколко дни.",
      },
    ],
  },
  faq: {
    headingPrefix: "Често Задавани",
    headingAccent: "Въпроси",
    intro:
      "Получете отговори на често задавани въпроси за нашите процедури с филъри за устни.",
    items: [
      {
        question: "Колко време издържат филърите за устни?",
        answer:
          "Филърите за устни обикновено издържат между 6-12 месеца, в зависимост от вида на използвания филър и индивидуалния ви метаболизъм. С течение на времето тялото естествено разгражда филъра, което изисква периодични корекции за поддържане на желания вид.",
      },
      {
        question: "Болезнена ли е процедурата с филъри за устни?",
        answer:
          "Прилагаме локален обезболяващ крем преди процедурата, за да сведем до минимум дискомфорта. Повечето пациенти съобщават само за лек натиск или леко щипане по време на инжектирането. Много филъри за устни също съдържат лидокаин, локален анестетик, за допълнително повишаване на комфорта по време на процедурата.",
      },
      {
        question: "Колко бързо ще видя резултати след филърите?",
        answer:
          "Ще видите незабавно увеличаване на обема след процедурата, въпреки че може да има първоначален оток. Крайните резултати стават видими след като отокът спадне, обикновено в рамките на 1-2 седмици след процедурата.",
      },
      {
        question: "Какво е времето за възстановяване след филъри за устни?",
        answer:
          "Повечето пациенти могат да се върнат към нормалните си дейности веднага след процедурата. Може да изпитате известен оток, синини или чувствителност за 2-3 дни. Препоръчваме да избягвате интензивна физическа активност за 24-48 часа след процедурата.",
      },
      {
        question: "Обратими ли са филърите, ако не харесам резултатите?",
        answer:
          "Да, филърите на основата на хиалуронова киселина (които използваме) могат да бъдат разтворени с ензим, наречен хиалуронидаза, ако не сте доволни от резултатите. Това е една от причините, поради които тези филъри са толкова популярни—те предлагат възможност за обратимост.",
      },
      {
        question: "Кой не е подходящ кандидат за филъри за устни?",
        answer:
          "Лица, които са бременни, кърмят, имат определени автоимунни заболявания, активен херпес или алергии към съставките на филъра, трябва да избягват уголемяване на устните. По време на консултацията ще прегледаме медицинската ви история, за да се уверим, че филърите за устни са безопасни за вас.",
      },
    ],
  },
};

export default lipFiller;

